import { render, staticRenderFns } from "./SetEnemGradesDialog.vue?vue&type=template&id=1c672202&"
import script from "./SetEnemGradesDialog.vue?vue&type=script&lang=js&"
export * from "./SetEnemGradesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports